<template>
    <div>

        <button v-if="TaskFolderList.length>0 && taskFolderId>0" class="btn btn-full btn-xxs rounded-s bg-magenta1-light font-900 mb-3 text-white w-100" @click="showFolderListModal=true">ارجاعات {{lableText('TaskName')??'وظیفه'}} ( {{ TaskFolderList.length }})</button>

        <transition name="modal" enter-active-class="animated fadeIn" appear>
            <div class="modal-mask" v-if="showFolderListModal">
                <div class="modal-wrapper2">
                    <div class="modal-container">
                        <div class="modal-body mb-0">
                            <slot name="body">
                                <div class="list-group list-custom-small list-icon-0">

                                    <div v-for="task in TaskFolderList" :key="task.taskFolderId" @click.prevent="showMenu(task.taskFolderId,task.childTaskId)">
                                        <div>
                                            <i class="fa fa-hashtag color-blue2-dark"></i>
                                            <span class="text-muted">{{task.taskFolderNo}}</span>

                                            <div class="float-left">
                                                <i class="fa fa-user color-green2-light"></i>
                                                <span class="text-muted">{{task.receiverUserTitle}}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <i class="fa fa-check color-red1-dark"></i>
                                            <span class="font-weight-bold">{{task.title}}</span>
                                        </div>
                                        <div>
                                            <i class="fa fa-check color-red1-dark"></i>
                                            <span>زمان شروع : </span>
                                            <span class="font-weight-bold">{{task.startDateTime}} - {{task.startTime}}</span>
                                        </div>
                                        <div>
                                            <i class="fa fa-check color-red1-dark"></i>
                                            <span>زمان پایان :</span>
                                            <span class="font-weight-bold"> {{task.endDateTime}} - {{task.endTime}}</span>
                                        </div>
                                        <div>
                                            <i class="fa fa-check color-red1-dark"></i>
                                            <span>درصد پیشرفت: </span>
                                            <span class="font-weight-bold">{{task.progressRate}}</span>
                                        </div>

                                    </div>
                                    <div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
                                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                                    </div>
                                </div>
                                <div v-if="TaskFolderList.length==0 && Loading==false">
                                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                                    <p class="text-center py-3">پیگیری برای این وظیفه ثبت نشده است</p>
                                </div>
                            </slot>
                        </div>
                        <div class="modal-footer py-1 px-2">
                            <slot name="footer">
                                <button class="btn btn-xxs rounded-s bg-red1-light" @click="showFolderListModal=false">
                                    بستن
                                </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

    export default {
        props: ['parentTaskFolderId','taskFolderId','taskId'],
        data() {
            return {
                page: 1,
                selectedTaskFolderId: null,
                showFolderListModal: false,
                loaded:false
            };
        },
        computed: {
           
            TaskFolderList() {
                if(this.loaded==false)
                {
                    return [];
                }
                var list=this.$store.getters.GetTaskFolderList;
                list=list.filter(x=>x.taskFolderId!=this.taskFolderId);
                return list;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            }
        },
        mounted() {
            this.getTaskFolderList();
            this.loaded=true;
        },
        methods: {
            getTaskFolderList() {
                this.$store.dispatch("GetTaskFolderListFromServer", {
                    pageId: this.page,
                    taskId: this.taskId,
                    taskFolderId: this.taskFolderId
                });
            },
            showMenu(taskFolderId, taskId) {
                this.showFolderListModal = false;
                this.$router.push({ name: 'EditTask', params: { taskFolderId: taskFolderId, taskId: taskId } });
               
            },
            
        },

    };</script>
<style>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper2 {
        display: table-cell;
        vertical-align: top;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        line-height: 1;
    }

    .modal-default-button {
        float: right;
    }


    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

        .modal-enter .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(2);
            transform: scale(2);
        }
</style>